import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5001/api';
console.log('API_URL:', API_URL);

// Create axios instance with default config
const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true // Enable sending cookies with requests
});

// Add request interceptor to add auth token
axiosInstance.interceptors.request.use(
    (config) => {
        // Ensure withCredentials is always true
        config.withCredentials = true;

        // Get token based on the request path/context
        let token = null;

        // Check for customer routes first
        if (config.url.startsWith('/customers') || config.url.startsWith('/customer-business')) {
            token = localStorage.getItem('customerToken');
            console.log('Using customer token for request:', config.url);
        }
        // Then check for agent routes
        else if (config.url.startsWith('/agents') || config.url.startsWith('/businesses')) {
            token = localStorage.getItem('agentToken');
        }
        // Finally check for admin routes
        else if (config.url.startsWith('/admin')) {
            token = localStorage.getItem('adminToken');
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            console.log('Authorization header set:', config.headers.Authorization);
        } else {
            console.warn('No token found for request:', config.url);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle errors globally
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle network errors
        if (!error.response) {
            console.error('Network Error:', error.message);
            return Promise.reject({
                response: {
                    data: {
                        success: false,
                        message: 'Network error. Please check your internet connection and try again.'
                    }
                }
            });
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;